// extracted by mini-css-extract-plugin
module.exports = {"dark":"home_dark__275Bz","light":"home_light__2muTS"};